import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY, frontendSettings } from "../../../utils/consts";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import { getSetting, setSetting } from "../../../utils/frontendSettingsManager";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";
import { parseAxiosError } from "../../../utils/response";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import MasterBalancesFilter from "../../elements/masterBalances/MasterBalancesFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import Notification from "../../elements/notification/Notification";
import MaterialPagination from "../../styles/materialPagination";
import MaterialSwitch from "../../styles/materialSwitch";
import { StyledContentWrapper } from "../../styles/styledMain";

import { StyledHideSomeInfo } from "../../elements/hideSomeInfo/styledHideSomeInfo";
import { StyledMasterBalancesWrapper } from "../styledMasterBalances";
import MasterBalancesList from "./MasterBalancesList";

const MasterBalancesContainer = () => {
  const { t } = useTranslation("masterBalancesPage");
  const [balances, setBalances] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [fetch, setFetch] = useState(false);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true, false, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true, false, true),
    "amount[gt]": checkFilterItem(history, "amount[gt]", getSetting("hideZeroBalances") ?? null, true, false, true),
    "service.name": checkFilterItem(history, "service.name", null, false, false, true),
    "currency.asset": checkFilterItem(history, "currency.asset", null, false, false, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchBalances = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/master-balances" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setBalances(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchBalances();
  }, [filterData, fetch]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  const handleChangeSetting = (event) => {
    const value = event.target.checked ? 0 : null;

    setSetting(frontendSettings.hideZeroBalances, value);
    setFilterData({
      ...filterData,
      "amount[gt]": value,
      page: 1
    });
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledMasterBalancesWrapper>
          <div className="master-balances-head">
            <MasterBalancesFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
            <StyledHideSomeInfo>
              <div>
                {t("table.hideZeroBalances")}
              </div>
              <MaterialSwitch
                checked={filterData["amount[gt]"] == "0"}
                onChange={event => {handleChangeSetting(event)}}
                name="Hide zero balances"
              />
            </StyledHideSomeInfo>
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <MasterBalancesList
            t={t}
            balances={balances}
            setFetch={setFetch}
          />
          {totalPageCount > 0 &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledMasterBalancesWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default MasterBalancesContainer;